import { IdNameItem } from "@/interfaces";

export const getSelectOptions = function <T extends IdNameItem>(items: T[]) {
    return items.map(({ name, id }) => ({
        label: name,
        value: id
    }))
}